import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ProjectedPremierVolumeContent} from './ProjectedPremierVolumeContent';
import reportPayload from './reportPayload';

export const ProjectedPremierVolumeReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const updatedTitle = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', `Projected ${updatedTitle} Volume`)}
      description={tt(
        'description',
        `Projected volume from scheduled ${updatedTitle} orders (orders yet to process this month). This volume isn't guaranteed - just what is scheduled to process through the end of the month.`,
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ProjectedPremierVolumeContent}
    />
  );
};

export default withHOC(
  withTranslation('report.projectedPremierVolume'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME,
    popoverContentProps: {},
  }),
)(ProjectedPremierVolumeReport);
